/** Quick date ranges for Profiles Sourced / Profiles View (local calendar, en-CA). */

export function getDefaultProfilesWeekRange() {
  const to = new Date();
  const from = new Date();
  from.setDate(from.getDate() - 6);
  return {
    from: from.toLocaleDateString('en-CA'),
    to: to.toLocaleDateString('en-CA'),
  };
}

export function getTodayProfilesRange() {
  const today = new Date().toLocaleDateString('en-CA');
  return { from: today, to: today };
}

export function getYesterdayProfilesRange() {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const date = yesterday.toLocaleDateString('en-CA');
  return { from: date, to: date };
}

export function matchesDefaultProfilesWeekRange(fromDate, toDate) {
  if (!fromDate || !toDate) return false;
  const expected = getDefaultProfilesWeekRange();
  return fromDate === expected.from && toDate === expected.to;
}

export function matchesTodayProfilesRange(fromDate, toDate) {
  if (!fromDate || !toDate) return false;
  const expected = getTodayProfilesRange();
  return fromDate === expected.from && toDate === expected.to;
}

export function matchesYesterdayProfilesRange(fromDate, toDate) {
  if (!fromDate || !toDate) return false;
  const expected = getYesterdayProfilesRange();
  return fromDate === expected.from && toDate === expected.to;
}
